export const getActiveSectionId = (ids: string[], line: number) =>
  ids.find(id => {
    const rect = document.getElementById(id)?.getBoundingClientRect();
    return rect && line >= rect.top && line < rect.bottom;
  });
